import * as React from "react";
import ShapeLine from "../../shapes/ShapeLine";
import ShapeButton from "../../shapes/ShapeButton";
import ShapeToggleButton from "../../shapes/ShapeToggleButton";
import ShapeTextField from "../../shapes/ShapeTextField";

export interface PreviewBasketProps {
  modePopupBackgroundColor: string;
  loyaltyBannerBackgroundColor: string;
  modePopupButtonBackgroundColor: string;
  modePopupTextColor: any;
  modePopupButtonTextColor: any;
  loyaltyBannerTextColor: any;
}

/* Show user selected color for color preview box.
(textColor, loyaltyBannerBackgroundColor, modePopupButtonBackgroundColor) */
const PreviewBasket: React.FunctionComponent<PreviewBasketProps> = ({
  modePopupBackgroundColor,
  loyaltyBannerBackgroundColor,
  modePopupButtonBackgroundColor,
  modePopupTextColor,
  modePopupButtonTextColor,
  loyaltyBannerTextColor,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ShapeButton
          length={4}
          height={2}
          color={loyaltyBannerBackgroundColor}
          textColor={loyaltyBannerTextColor}
        />
      </div>

      <div>
        <div style={{ margin: 16 }}></div>
        <ShapeTextField bgColor={modePopupBackgroundColor} />
        <div style={{ margin: 16 }}></div>
        <ShapeTextField bgColor={modePopupBackgroundColor} />
        <div style={{ margin: 16 }}></div>
        <ShapeTextField bgColor={modePopupBackgroundColor} />
        <div style={{ margin: 16 }}></div>
        <ShapeLine length={5} color={modePopupTextColor} />
        <div style={{ margin: 16 }}></div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <ShapeButton
            length={4}
            height={2}
            color={modePopupTextColor}
            textColor={modePopupBackgroundColor}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <ShapeButton
            length={4}
            height={2}
            color={modePopupTextColor}
            textColor={modePopupBackgroundColor}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <ShapeButton
            length={2}
            height={2}
            color={modePopupButtonBackgroundColor}
            textColor={modePopupButtonTextColor}
          />
          <div style={{ margin: 4 }}></div>
          <ShapeButton
            length={2}
            height={2}
            color={modePopupButtonBackgroundColor}
            textColor={modePopupButtonTextColor}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviewBasket;
